import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React component to scroll to the top on location changes
export default function ScrollToTop() {
  // Get the current location object using the useLocation hook
  const { pathname, search } = useLocation();

  // useEffect is used to perform side effects in function components
  useEffect(() => {
    // Check if the search query parameter "sub" is not set to true
    if (!search || !search?.includes("sub=true")) {
      // Scroll the window to the top
      window.scrollTo({
        top: 0,
        left: 0,
      });
    }
  }, [pathname, search]); // Trigger the effect when pathname or search changes

  // The component doesn't render anything (returns null)
  return null;
}
